import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon, IconType } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

interface Props {
  selectedValue: string
  value: string
  icon: IconType
  label: string
  onChange: (value: string) => void
}

const Selector = observer(({ selectedValue, value, icon, label, onChange }: Props) => {
  return (
    <Box
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="s8"
      onClick={() => onChange(value)}
      className={`${value == selectedValue ? 'bg-f1-background-secondary' : ''}`}
      paddingTop="s6"
      paddingBottom="s6"
      paddingLeft="s4"
      paddingRight="s4"
      width="full"
      borderRadius={{ all: 'abs010' }}
    >
      <F0Icon icon={icon} size="md" color={value == selectedValue ? 'default' : 'secondary'} />
      <Text.Normal
        className={`${
          value == selectedValue ? 'text-f1-foreground' : 'text-f1-foreground-secondary'
        }`}
      >
        {label}
      </Text.Normal>
    </Box>
  )
})

export { Selector }
